import { requestsLikeGenerate } from '../requestsLike.js';
/**
 * python/httpx_sync
 */
export const pythonHttpxSync = {
    target: 'python',
    client: 'httpx_sync',
    title: 'HTTPX (Sync)',
    generate(request, configuration) {
        return requestsLikeGenerate('httpx', request, configuration, 'httpx');
    },
};
